import React from "react";
import { MapPin, Phone, Instagram, MessageCircle, Map } from "lucide-react";
import { CONTACT, ADDRESSES, whatsappLink, WHATSAPP_NUMBER, LOGO_IMG } from "../../lib/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0A2540] text-white/85">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
        {/* Brand */}
        <div className="lg:col-span-4">
          <div className="flex items-center gap-3 mb-5">
            <img
              src={LOGO_IMG}
              alt="Dra. Luz Adriana — logo"
              className="w-12 h-12 rounded-full object-cover ring-1 ring-[#D4AF37]/40"
            />
            <div>
              <p className="font-serif-display text-xl text-white leading-none">
                {CONTACT.fullName}
              </p>
              <p className="text-xs text-white/60 mt-1">
                Especialista em tratamento da dor
              </p>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-white/65 max-w-md">
            Tratamento com Toxina Botulínica para enxaqueca, cefaleias, dores
            musculares e neuropatias. Cuidado humanizado e individualizado para
            sua qualidade de vida.
          </p>

          <div className="mt-6 space-y-3 text-sm">
            <div className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
              <a href={`tel:+5521975203353`} className="hover:text-[#D4AF37]">
                {CONTACT.phoneDisplay}
              </a>
            </div>
            <div className="flex items-center gap-3">
              <MessageCircle className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#D4AF37]"
              >
                WhatsApp +{WHATSAPP_NUMBER}
              </a>
            </div>
            <div className="flex items-center gap-3">
              <Instagram className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
              <a
                href={CONTACT.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#D4AF37]"
                data-testid="footer-instagram"
              >
                {CONTACT.instagramHandle}
              </a>
            </div>
          </div>
        </div>

        {/* Endereços */}
        <div className="lg:col-span-8">
          <h4 className="overline text-[#D4AF37] mb-6">Endereços de Atendimento</h4>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {ADDRESSES.map((addr, i) => (
              <div
                key={addr.label}
                data-testid={`footer-address-${i}`}
                className="bg-white/[0.04] border border-white/10 rounded-lg p-5 flex flex-col"
              >
                <MapPin className="w-5 h-5 text-[#D4AF37] mb-3" />
                <p className="text-xs uppercase tracking-widest text-white/55 mb-2">
                  {addr.label}
                </p>
                <p className="text-sm text-white leading-snug">{addr.line}</p>
                <p className="text-xs text-white/60 mt-1 leading-snug">{addr.city}</p>
                <a
                  href={addr.mapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-maps-${i}`}
                  className="mt-4 inline-flex items-center gap-2 text-xs text-[#D4AF37] hover:text-[#E5C158] transition-colors"
                >
                  <Map className="w-3.5 h-3.5" />
                  Como chegar
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/55">
          <p>
            © {new Date().getFullYear()} {CONTACT.fullName}. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-[#D4AF37]" data-testid="footer-privacy">
              Política de Privacidade
            </a>
            <a href="#" className="hover:text-[#D4AF37]" data-testid="footer-lgpd">
              LGPD
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
